import React, { useEffect, useState, useRef } from 'react'
import { message, Cascader, Modal, Form, Input, Button, Space } from 'antd'
import { infoOrg, editOrg, resetPassword } from "../../http/modules/organization";
import { getSignInCode } from "../../http/modules/login";
import { provincial } from "../../components/diqu";
import './index.scss'

export default function HomeCentre() {

  // 是否修改信息
  const [xiuGai, setXiuGai] = useState('0')
  // 机构基本信息
  const [info, setInfo] = useState('')
  // 机构名称
  const [orgName, setOrgName] = useState()
  // 机构地区
  const [province, setProvince] = useState([])
  // 修改密码
  const [isModalOpen, setIsModalOpen] = useState(false);
  // 验证码是否可以点击
  const [sendDisable, setSendDisable] = useState(false);
  const timeRef = useRef(null);
  const [countdown, setCountdown] = useState(60);
  // 手机号
  const [phone, setPhone] = useState("");


  // 机构详情
  const onFinish = async (values) => {
    const res = await infoOrg();
    if (res.code == 0) {
      setInfo(res.data)
    } else {
      message.error(res.msg);
    }
  };

  // 修改机构信息
  const onEditOrg = async () => {
    const res = await editOrg({
      "orgName": orgName || info?.org?.name,
      "province": province.province || info?.org?.province,
      "city": province.city || info?.org?.city,
      "county": province.county || info?.org?.county
    });
    if (res.code == 0) {
      message.success('修改成功');
      setOrgName('')
      setProvince('')
      onFinish()
      setXiuGai('0')
    } else {
      message.error('修改失败');
    }
  };

  // 机构所在地
  const RegistLoc = (value) => {
    if(value[0]=='新疆生产建设兵团'){
      setProvince({
        province: value[0],
        city: value[0],
        county: value[0],
      });
    }else{
      setProvince({
        province: value[0],
        city: value[1],
        county: value[2],
      });
    }
  }

  useEffect(() => {
    onFinish()
  }, [])

  // 修改密码确定
  const handleOk = async (value) => {
    const res = await resetPassword({
      "phone": value.phone,
      "smsCode": value.smsCode,
      "password1": value.password1,
      "password2": value.password2
    });
    if (res.code == 0) {
      message.success('修改密码成功');
      setIsModalOpen(false);
    } else {
      message.error(res.msg);
    }
  };
  // 修改密码取消
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  //、发送短信验证码
  const getVerificationCode = async () => {
    if (!phone) {
      message.error("请输入手机号");
      return;
    } else {
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        message.success("手机格式有误");
        return;
      } else {
        timeRef.current = 60;
        setTimer();
        setSendDisable(true);
        cationCode();
      }
    }
  };
  //注册发送短信验证码
  const cationCode = async () => {
    try {
      // setLoading(true);
      const res = await getSignInCode({
        phone: phone
      })
      if (Number(res.code) == 0) {
        message.success('短信已成功发送')
      } else {
        message.success(res.msg)
      }
    } finally {
      // setLoading(false);
    }
  };
  // 倒计时
  const setTimer = () => {
    let timer = setInterval(() => {
      if (timeRef.current > 0) {
        timeRef.current--;
        setCountdown(timeRef.current);
      } else {
        setCountdown(60);
        setSendDisable(false);
        clearInterval(timer);
      }
    }, 1000);
  };


  return (
    <div className='homeCentre'>
      <header>
        <p></p>
        基础信息
      </header>

      <main>
        <p>
          <span>用户名</span>
          <input disabled type="text" value={info?.orgAdmin?.loginName || ''} />
        </p>
        <p>
          <span>手机号</span>
          <input disabled type="text" value={info?.orgAdmin?.phone || ''} />
        </p> <p>
          <span>机构名称</span>
          {xiuGai == '1' ? <>
            <input className='inputs1' type="text" value={orgName} onChange={(e) => { setOrgName(e.target.value); }} />
            <span className='span1' onClick={() => onEditOrg()} style={{cursor:'pointer'}}>确定 </span>
          </>
            : <>
              <input className='inputs1' type="text" value={info?.org?.name || ''} />
              <span className='span1' onClick={() => setXiuGai('1')} style={{cursor:'pointer'}}> 修改 </span>
            </>}
        </p> <p>
          <span>机构地区</span>
          {xiuGai == '2' ? <>
            <Cascader className='Cascader' options={provincial} onChange={RegistLoc} />
            <span className='span1' onClick={() => onEditOrg()} style={{cursor:'pointer'}}> 确定 </span>
          </>
            : <>
              <input className='inputs1' type="text" value={info?.org?.county || info?.org?.province || ''} />
              <span className='span1' onClick={() => setXiuGai('2')} style={{cursor:'pointer'}}> 修改 </span>
            </>}

        </p><p>
          <span>密码</span>
          <span className='span1' onClick={() => setIsModalOpen(true)} style={{cursor:'pointer',fontSize:'18px'}}> 密码重置 </span>
        </p>
        <Modal className='modal' closable={false} destroyOnClose={true} bodyStyle={{ paddingLeft: '20%' }} footer={null} title="修改密码" open={isModalOpen} >
          <Form
            name="basic"
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 20,
            }}
            initialValues={{
              remember: true,
            }}
            onFinish={handleOk}
            autoComplete="off"
          >
            <Form.Item
              label=""
              name="phone"
              rules={[
                { required: true, message: "请输入正确的手机号" },
                {
                    pattern: new RegExp(/^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/),
                    message: "请输入正确的手机号！"
                }
            ]}
            >
              <Input value={phone} onChange={e => {
                setPhone(e.target.value);
              }} placeholder='手机号' />
            </Form.Item>

            <Form.Item
              label=""
              name="smsCode"
              rules={[
                {
                  required: true,
                  message: 'Please input your password!',
                },
              ]}
            >
              <Space>
                <Input.Password col={15} maxLength={6} placeholder="请输入验证码" />
                <Button col={7} disabled={sendDisable} type="link" onClick={getVerificationCode} /* className="anniu-fasong-yzms" */>
                  发送验证码
                  {sendDisable && <span>({countdown})</span>}
                </Button>
              </Space>
            </Form.Item>

            <Form.Item
              label=""
              name="password1"
              rules={[{ required: true, message: '请输入密码!' },
              {
                  pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{3,200}$/),
                  message: "至少1个大写字母,1个小写字母和1个数字"
              }
              ]}
            >
              <Input placeholder='请输入新密码' />
            </Form.Item>

            <Form.Item
              label=""
              name="password2"
              rules={[
                {
                  required: true,
                  message: '请再次输入密码!',
                },
              ]}
            >
              <Input.Password placeholder='再次输入新密码' />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit">
                确定
              </Button>
              <Button htmlType="button" onClick={handleCancel}>
                取消
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </main>
    </div>
  )
}
